<template>
    <div class="teacher">
        <!-- banner -->
        <div class="banner">
            <div class="img"><img src="@/assets/img/ggu_logo.png" alt=""></div>
            <p>世毕盟本科
                <span>咨询团队</span>
            </p>
        </div>
        <!-- list -->
        <div class="list">
            <ul>
                <li v-for="(item,index) in teacherList" :key="index">
                    <div class="left">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="right">
                        <p class="name">{{item.name}} <span>{{item.label}}</span></p>
                        <p class="info">{{item.info}}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

// import api from "@/api/apply";   
export default {
    data() {
        return {
            dataImgUrl:"http://www.gguconsulting.com/try/sbm/Public/GGUExper_files/",
            wxImg: "http://www.gguconsulting.com/try/sbm/Public/img/ggu_logo.jpg",
            teacherList:[{
                name:"龚晓然",
                img:require("@/assets/img/gong.jpg"),
                label:"世毕盟创始人",
                info:"清华大学硕士， 多年美国留学培训及咨询经验，学生遍及美国各大名校。"
            },{
                name:"Chloe",
                img:require("@/assets/img/Chloe.jpg"),
                label:"MIT本科",
                info:"4年MIT本科面试和招生工作经验，丰富指导世毕盟学员申请美国、英国名校本科项目的工作经验。"
            },{
                name:"Ying",
                img:require("@/assets/img/Ying.jpg"),
                label:"Duke University本科",
                info:"多年Duke本科面试工作经验，丰富指导世毕盟学员申请美国名校本科项目的工作经验。"
            },{
                name:"Diane",
                img:require("@/assets/img/Diane.jpg"),
                label:"Harvard University本科",
                info:"哈佛商学院MBA毕业，多年Harvard面试工作经验，丰富指导世毕盟学员申请美国、英国名校本科项目的工作经验。"
            },{
                name:"Yuan",
                img:require("@/assets/img/Yuan.jpg"),
                label:"Grinnell College本科",
                info:"丰富指导世毕盟学员申请美国、英国名校本科项目的工作经验。"
            },{
                name:"Sierra",
                img:require("@/assets/img/Sierra.jpg"),
                label:"Stanford University本科",
                info:"2年Stanford本科招生材料审阅工作经验，丰富指导世毕盟学员申请美国名校本科项目的工作经验。"
            },{
                name: "Tylor",
                img: require('@/assets/img/Tylor.jpg'),
                label: "Harvard University本科",
                info: "Harvard本科毕业，丰富的指导世毕盟学员申请美国和英国大学的工作经验。",
            }]
        }
    },
    methods:{
        //获取offer数据
        // async getApplyData(){
        //     try {
        //         let re = await api.apply_undergraduate_list();
        //         this.applyData = re.data.data.list;
        //     } catch (error) {
        //         console.error(error);
        //     }
        // }
    },
    created(){
        this.WXConfig.wxShowMenu("世毕盟本科申请","美英top名校申请专家，让你脱颖而出！","http://www.gguconsulting.com/try/sbm/index.php/#/applyteacher",this.wxImg);
        // this.getApplyData();
    }
}
</script>

<style lang="less" scoped>
.teacher {
    background:#fff;
    // font-family: 'PingFang Regular';
    .banner {
        width: 100%;
        height: 360px;
        position: relative;
        background:url("../../assets/img/apply_b_t.jpg") no-repeat;
        background-size:100% auto;
        background-position:0 center;
        p {
            padding-top: 125px;
            text-align: center;
            font-size: 47px;
            color: #fff;
            span {
                color: #FEEA8B;
            }
        }
        .img {
            width: 170px;
            // height: 38px;
            position: absolute;
            top: 40px;
            left: 43px;
            img {
                width: 100%;
                // height: 100%;
            }
        }
    }
    .list{
        padding:0 25px 100px;
        margin-top:40px;
        ul{
            // margin-top:20px;
            li{
                border:1px solid rgba(204,204,204,1);
                border-radius:20px;
                margin-bottom:20px;
                display:flex;
                padding:37px 28px;
                .left{
                    width:114px;
                    height:148px;
                    background:#ddd;
                    margin-right:30px;
                    img{
                        width:100%;
                        height:100%;
                    }
                }
                .right{
                    flex:1;
                    .name{
                        font-size:32px;
                        color:#000000;
                        span{
                            display:inline-block;
                            padding:0px 15px;
                            border-radius:17px;
                            background:#FECB5F;
                            color:#080808;
                            font-size:24px;
                            line-height:32px;
                            margin-left:15px;
                            vertical-align: middle;
                            margin-top:-10px;
                        }
                    }
                    .info{
                        margin-top:20px;
                        font-size:26px;
                        color:#4D4D4D;
                        line-height:44px;
                    }
                }
            }
        }
    }
    .loading{
        text-align: center;
        height:200px;
        .van-loading{
            width:100%;
            margin-top:200px;
            color:#000 !important;
        }
    }
}
</style>